import { View } from "react-native";
import UserSettingsPage from "@/app/(app)/settings/user";
import { useBottomTabOverflow } from "@/components/ui/TabBarBackground";

export default function PreferencesPage() {
  const bottom = useBottomTabOverflow();
  return (
    <View style={{ flex: 1, padding: 16, paddingBottom: bottom + 1 }}>
      <UserSettingsPage />
    </View>
  );
}
